// extracted by mini-css-extract-plugin
module.exports = {"liveViewModal":"styles_liveViewModal__1kaRB","content":"styles_content__3lgIR","icon":"styles_icon__1jyOe","turnOffDescription":"styles_turnOffDescription__3h5we"};